/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsUpdateProfile204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsUpdateProfile505Schema = z.any();

export const optionsUpdateProfileMutationResponseSchema = z.lazy(() => optionsUpdateProfile204Schema);
